(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("react-addons-transition-group"));
	else if(typeof define === 'function' && define.amd)
		define("AvailityReactstrapValidation", ["react", "react-dom", "react-addons-transition-group"], factory);
	else if(typeof exports === 'object')
		exports["AvailityReactstrapValidation"] = factory(require("react"), require("react-dom"), require("react-addons-transition-group"));
	else
		root["AvailityReactstrapValidation"] = factory(root["React"], root["ReactDOM"], root["React"]["addons"]["TransitionGroup"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_202__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/